
export default {
    filters: {profileCompleted: false, selected: [],
        needRefreshSearch: false, qSearch: "", location: "", initialFilters: {}},
    userStatus: {}
}